// React
import React, {Component} from 'react';
// Components
import {Dialog, DialogContent, IconButton, Divider} from '@material-ui/core';
import {CopyBlock, dracula} from "react-code-blocks";
// Svg
import {codeSvg} from "@assets";
// Styles
import './styles.scss';
// Helpers
import {getCodeScript} from "@helpers";

export class Copy extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false
        }
    }

    handleDialogAction = (dialog, action) => {
        this.setState({[dialog]: action});
    }

    render() {
        const {t, className, type, project_id, chat_id} = this.props;
        const {open} = this.state;
        return (
            <React.Fragment>
                <IconButton className={ className ? `platform_copy_${className}` : 'platform_copy_primary'} onClick={() => this.handleDialogAction("open", true)}
                            style={{backgroundColor: 'transparent'}} disableRipple
                            disableFocusRipple
                            aria-label="delete">
                    {codeSvg()}
                </IconButton>
                <Dialog className="copy_main dialog_create" onClose={() => this.handleDialogAction("open", false)} open={open}>
                    <DialogContent>
                        <h4>{t(`commons:modals.copy.${type}.title`)}</h4>
                        <Divider/>
                        <div className={"copy_main__content"}>
                            <span>Widget</span>
                            <p className="p2">{t(`commons:modals.copy.${type}.widget_description`)}</p>
                            <CopyBlock
                                text={getCodeScript('widget', project_id, chat_id)}
                                language={"html"}
                                showLineNumbers={true}
                                theme={dracula}
                                wrapLines={true}
                                codeBlock
                            />
                            <Divider/>
                            <span>Div</span>
                            <p className="p2">{t(`commons:modals.copy.${type}.div_description`)}</p>
                            <CopyBlock
                                text={getCodeScript('div', project_id, chat_id)}
                                language={"html"}
                                showLineNumbers={true}
                                theme={dracula}
                                wrapLines={true}
                                codeBlock
                            />
                        </div>
                    </DialogContent>
                </Dialog>
            </React.Fragment>

        );
    }
}
